// Money is stored in MINOR UNITS (cents) everywhere in Firestore: a transaction
// total of 16250 is LSL 162.50, a product basePrice of 250000 is LSL 2,500.00.
//
// Amounts are kept as integer cents all the way through the services and any
// arithmetic built on them (sums, averages, stock value), and converted to major
// units only here, at the point of display. That keeps totals exact - summing
// floats like 162.50 accumulates rounding error, summing 16250 does not.
export const CENTS_IN_UNIT = 100;

// The dashboard shows exactly one business at a time, and most money is
// rendered by pure presentational components with no access to the business
// context. Rather than thread a currency prop through every one of them, the
// resolved code is held here and set once by useBusiness().
let displayCurrency = "KES";

export function setDisplayCurrency(code) {
  if (typeof code === "string" && code.trim()) displayCurrency = code.trim();
}

export function getDisplayCurrency() {
  return displayCurrency;
}

export const formatCurrency = (amountInCents, currency) => {
  if (typeof amountInCents !== "number" || !Number.isFinite(amountInCents)) {
    return amountInCents;
  }
  return `${currency || displayCurrency} ${(amountInCents / CENTS_IN_UNIT).toLocaleString(
    "en-KE",
    { minimumFractionDigits: 2, maximumFractionDigits: 2 }
  )}`;
};
